export default {"src":"/_next/static/media/instagram_icon.2fba42ce.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};